import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthserviceService } from '../@core/services/authservice.service';

export const passwordChangeGuard: CanActivateFn = () => {
  const auth = inject(AuthserviceService);
  const router = inject(Router);
  if (!auth.isLoggedIn || !auth.usuarioValue) return router.parseUrl('/login-portal');
  return true;
};
